import { render } from "./PageNotFound.vue?vue&type=template&id=60eb0d5f"
const script = {}

import exportComponent from "E:\\jev-router\\runs\\dating-services-20261022\\build-workspace\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__